// client/src/pages/ExamDetails.js

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../api";

function ExamDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [exam, setExam] = useState(null);
  const [hasActiveAttempt, setHasActiveAttempt] = useState(false);

  useEffect(() => {
    const fetchExam = async () => {
      try {
        const res = await api.get(`/api/exams/${id}`);
        setExam(res.data);
        try {
          const attemptsRes = await api.get("/api/attempts/my");
          const attempts = attemptsRes.data || [];
          const active = attempts.some(
            (a) =>
              a.examId &&
              a.examId._id === id &&
              !a.revoked &&
              a.status !== "failed"
          );
          setHasActiveAttempt(active);
        } catch (e) {
          console.error(
            "Failed to check attempts for this exam:",
            e.response?.data || e.message
          );
        }
      } catch (err) {
        console.error("Failed to fetch exam:", err);
      }
    };

    fetchExam();
  }, [id]);

  if (!exam) return <div>Loading...</div>;

  return (
    <div style={{ padding: 40 }}>
      <h1>{exam.title}</h1>

      <p>{exam.description}</p>

      <p><strong>Price:</strong> ₹{exam.price}</p>
      <p><strong>Duration:</strong> {exam.durationMinutes} minutes</p>
      <p><strong>Total Questions:</strong> {exam.totalQuestions}</p>
      <p><strong>Pass Score:</strong> {exam.passScore}%</p>

      {!hasActiveAttempt ? (
        <button
          onClick={() => navigate(`/checkout/${exam._id}`)}
          style={{
            padding: "12px 24px",
            fontSize: 16,
            marginTop: 20,
            cursor: "pointer"
          }}
        >
          Get Certified
        </button>
      ) : (
        <p style={{ marginTop: 20, color: "green" }}>
          You already have an active attempt for this certification.
        </p>
      )}
    </div>
  );
}

export default ExamDetails;